export default {

  password: {
    rule: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
    text: '最少八个字符，至少一个大写字母，一个小写字母和一个数字'
  },

  phone: {
    rule: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/,
    text: '手机号不正确或不支持'
  },

  tel: {
    rule: /^(\d{3,4}-)?\d{7,8}$/,
    text: '座机不正确或不支持'
  },

  email: {
    rule: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
    text: '邮箱不正确或不支持'
  }

}